import { render, staticRenderFns } from "./market-break-down.page.vue?vue&type=template&id=c43a8c9c&scoped=true"
import script from "./market-break-down.page.vue?vue&type=script&lang=ts"
export * from "./market-break-down.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43a8c9c",
  null
  
)

export default component.exports